/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { File } from './File';

export type ManualFacialRecognitionRequest = {
  documentType: ManualFacialRecognitionRequest.documentType;
  documentNumber: string;
  documentFrontImg: File;
  documentBackImg: File;
  faceImg: File;
  nome: string;
  cpf: string;
};

export namespace ManualFacialRecognitionRequest {

  export enum documentType {
    RG = 'RG',
    CNH = 'CNH',
  }


}

